export enum MediaType {
  IMAGE = "Image",
  VIDEO = "Video",
  ZIP = "Zip",
  PDF = "Pdf",
  PPT = "PowerPoint",
  SHEET = "Sheet",
  WORD = "WordDocument",
  UNKNOWN = "Unknown",
}

export const MEDIA_TYPES: Record<string, MediaType> = {
  "image/jpeg": MediaType.IMAGE,
  "image/png": MediaType.IMAGE,
  "video/mp4": MediaType.VIDEO,
  "application/zip": MediaType.ZIP,
  "application/pdf": MediaType.PDF,
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": MediaType.PPT,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": MediaType.SHEET,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": MediaType.WORD,
  "application/x-unknown": MediaType.UNKNOWN,
};
